import themes from 'devextreme/ui/themes';

export type AppTheme = 'light' | 'dark';

/**
 * The DevExtreme theme behind each app theme. Both are linked from index.html as
 * `link[rel=dx-theme]`, which is what lets themes.current() swap them at runtime.
 */
export const DX_THEMES: { [key in AppTheme]: string } = {
  light: 'generic.carmine',
  dark: 'generic.dark'
};

/** Marker class on <html>; every non-DevExtreme dark rule hangs off it (see src/scss/_dark.scss). */
export const DARK_CLASS = 'dark-theme';

/**
 * Swaps the DevExtreme stylesheet and flips the app's own palette to match.
 *
 * DevExtreme 21.1 does not repaint widgets on a theme change, but the swap is
 * pure CSS so the only thing that goes stale is geometry the widgets measured
 * themselves (grid column widths, scroll views). A resize event once the new
 * sheet has loaded makes them re-measure.
 */
export function applyTheme(theme: AppTheme): void {
  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add(DARK_CLASS);
  } else {
    root.classList.remove(DARK_CLASS);
  }

  if (themes.current() === DX_THEMES[theme]) { return; }

  // Registered before the switch: themes.current() only waits for the new sheet
  // when a ready callback is pending, and fires (then drops) it once loaded.
  themes.ready(() => window.dispatchEvent(new Event('resize')));
  themes.current(DX_THEMES[theme]);
}
